<app-breadcrumb
  [master]="'Dobry Agent'"
  [parentName]="'Artykuły'"
  [name]="'Szczegóły'"
></app-breadcrumb>

<mat-tab-group>
  <mat-tab label="Dane">
    <app-da-article-details-view
      *ngIf="!modify"
      [blogArticle]="blogArticle"
      (modifyClicked)="modify = true"
    ></app-da-article-details-view>

    <app-da-article-add
      *ngIf="modify && blogArticleObject"
      [blogArticle]="blogArticleObject"
      [mod]="true"
      (closeModification)="onModificationClosed()"
    ></app-da-article-add>
  </mat-tab>
</mat-tab-group>
